/**
 * 时间格式化
 * @param date    接收可以被new Date()方法转换的内容
 * @param format  字符串，需要的格式例如：'yyyy-MM-dd hh:mm:ss'
 * @returns {String}
 */
export const dateFormatter = (date, format = 'yyyy-MM-dd') => {
  if (!date) {
    return '-';
  }

  const newDate = new Date(typeof date === 'string' && isNaN(date) ? date.replace(/-/g, '/') : date);
  const o = {
    'M+': newDate.getMonth() + 1,
    'd+': newDate.getDate(),
    'h+': newDate.getHours(),
    'm+': newDate.getMinutes(),
    's+': newDate.getSeconds(),
    'q+': Math.floor((newDate.getMonth() + 3) / 3),
    'S': newDate.getMilliseconds()
  };

  let newFormat = '';

  if (/(y+)/.test(format)) {
    newFormat = format.replace(RegExp.$1, (String(newDate.getFullYear())).substr(4 - RegExp.$1.length));
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(newFormat)) {
      newFormat = newFormat.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr((String(o[k])).length)));
    }
  }
  return newFormat;
};

export const getNextDay = (date, day) => {
  let newDate = new Date(date);

  newDate = Number(newDate) + (day * 1000 * 60 * 60 * 24 || 0);
  newDate = new Date(newDate);
  return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
};

export function isSameDay(date1, date2) {
  return dateFormatter(date1) === dateFormatter(date2);
}

export const decimalsToFractional = (decimals, split = '/') => {
  const formatDecimals = decimals.toFixed(2);

  let denominator = 100; // 初始化分母

  let numerator = formatDecimals * 100; // 初始化分子

  let bigger = 0;

  function recursion() {
    bigger = denominator > numerator ? denominator : numerator;
    for (let i = bigger; i > 1; i--) {
      if (Number.isInteger(numerator / i) && Number.isInteger(denominator / i)) {
        numerator = numerator / i;
        denominator = denominator / i;
        recursion();
      }
    }
  }
  recursion();
  return `${numerator}${split}${denominator}`;
};

/**
 * 对小数部分不能补足0的金额补足0
 * @param decimals 传入的金额
 * @param fixed 需要保留的小数位数
 * @param rate 需要转化的进制层级，例如传入的金额单位为分，需要得到元，则应传入2
 */
export const decimalsFixedDoubleZero = (decimals, fixed = 2, rate = 0) => {
  if (!decimals) {
    return '0.00';
  }
  let tempDecimals = Math.round(parseFloat(decimals) * Math.pow(10, fixed)) / Math.pow(10, fixed);

  tempDecimals = tempDecimals / Math.pow(10, rate);
  const decimalArr = (String(tempDecimals)).split('.');

  if (decimalArr.length === 1) {
    return decimalArr[0] + '.00';
  }
  for (let i = decimalArr[1].length; i < fixed; i++) {
    tempDecimals += '0';
  }
  return tempDecimals;
};

export const decimalsToThousandBit = (decimals, fixed = 2) => {
  if (!decimals) {
    const ZERO = 0;

    return ZERO.toFixed(fixed);
  }
  const regExpInfo = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;

  const ret = parseFloat(decimals).toFixed(fixed).toString().replace(regExpInfo, '$1,');

  return ret;
};
